import application from './application.json'

export default { application }